import { Component } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { readStory, Story } from '../../../../shared/interfaces/story';
import { ConsoleLoggerService } from '../../../../core/services/console-logger.service';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { StoryService } from '../../../../shared/services/story.service';
import { nav_path } from '../../../../app-routing.module';
import { Router } from '@angular/router';

@Component({
  selector: 'anon-admin-stories',
  templateUrl: './admin-stories.component.html',
  styleUrls: ['./admin-stories.component.scss']
})
export class AdminStoriesComponent {
  stories$: Observable<Story[]>;
  error: any;
  public nav_path = nav_path;

  constructor(
    private db: FirestoreService,
    private logs: ConsoleLoggerService,
    private storyService: StoryService,
    private router: Router
  ) {
    this.stories$ = this.db.col$(`stories`, { idField: 'id' })
      .pipe(
        map(stories => this.storyService.sort(stories as readStory[], 'desc')),
        catchError(error => {
          this.logs.error(`error getting admin stories`, error);
          this.error = error;
          return throwError(error);
        })
      );
  }

  storyFeaturedChanged(change: MatSlideToggleChange, story: Story) {
    this.db.update(`stories/${story.id}`, { featured: change.checked });
  }
  storyPublicChanged(change: MatSlideToggleChange, story: Story) {
    this.db.update(`stories/${story.id}`, { visibility: change.checked ? 'public' : 'private' });
  }

  deleteStory(story: Story) {
    this.db.delete(`stories/${story.id}`)
      .then(() => this.router.navigate([nav_path.adminStories]));
  }
}
